export const buildSalesRecommendationModalConfig = ({ actions, ctx, components, uiState }) => {
  const {
    setInputs,
    setOpenOrderConfirmation,
    setAppliedFiltersCount,
    setSelectedProductIds,
    setSelectedSupplierFromFilter,
    setShowFilters,
    setShowInputs,
    setShowCancelModal,
    setShowSuccessModal,
    setSharedAppliedLevels,
    setSharedSelectedLevels,
    setSharedTypedExpression,
    setSharedAppliedExpression,    
  } = actions;

  const {
    tableInfo,
    filteredData,
    purchaseRecommendationDataOnly,
    totalProducts,
    prefixes,
    productsWithoutSupplierCount,
    selectedSupplierFromFilter,
    supplierProductRelations,
    blockedProductsList,
    productIds,
    updatedProductsList,
    t,
    hierarchyNames,
    products
  } = ctx;

  const {
    inputs,
    showInputs,
    openOrderConfirmation,
    appliedFiltersCount,
    purchaseOrderEligibility,
    sharedAppliedLevels,
    showSuccessModal,
    showCancelModal,
    sharedSelectedLevels,
    sharedTypedExpression,
    sharedAppliedExpression,    
  } = uiState;

  return {
    modalState: {
      openOrderConfirmation: openOrderConfirmation,
      showCancelModal: showCancelModal,
      showSuccessModal: showSuccessModal,
    },
    components: {
      openOrderConfirmation: components.SupplierConfirmationModal,
      showCancelModal: components.CancelModalButton,
      showSuccessModal: components.SuccessModal,
    },
    propsMap: {
      openOrderConfirmation: {
        t,
        actions: {
          setInputs,
          onClose: () => setOpenOrderConfirmation(false),
          onOrderCreated: () => {
            setOpenOrderConfirmation(false);
            setSharedAppliedLevels({});
            setSharedSelectedLevels({});
            setSharedTypedExpression("");
            setSharedAppliedExpression("");
            setAppliedFiltersCount(0);
            setSelectedProductIds([]);
            setSelectedSupplierFromFilter(null);
            setShowFilters(false);
          },
          setAppliedFiltersCount,
          setSelectedProductIds,
          setShowFilters,
          setSelectedSupplierFromFilter,
          setAppliedLevels: setSharedAppliedLevels,
          setSelectedLevels: setSharedSelectedLevels,
          setTypedExpression: setSharedTypedExpression,
          setAppliedExpression: setSharedAppliedExpression,
        },
        ctx: {
          tableInfo,
          filteredData,
          purchaseRecommendationDataOnly,
          totalProducts,
          prefixes,
          productsWithoutSupplierCount,
          selectedSupplierFromFilter,
          suppliersAndProductRelations: supplierProductRelations,
          productIds,
          products,
          hierarchyNames,
          labels: {
            principalMessage: t("missingSuppliersInfo"),
            additionalInformationWarning: t("productsAmount"),
            firstButtonLabel: t("return"),
            secondButtonLabel: t("proceed"),
            upperCardMessage: t("confirmSupplier"),
            lowerCardMessage: t("currentSupplierSelected"),
            notificationMessage: t("youMustSelectASupplier"),
            additionalInformationUpperRightCard: t("store"),
            additionalInformationDownRightCard: t("address"),
          },
        },
        uiState: {
          inputs,
          showInputs,
          openOrderConfirmation,
          appliedFiltersCount,
          appliedLevels: sharedAppliedLevels,
          selectedLevels: sharedSelectedLevels,
          typedExpression: sharedTypedExpression,
          appliedExpression: sharedAppliedExpression,
          hasValidItemsForOrder: purchaseOrderEligibility?.withOriginalValues,
        },
      },
      showCancelModal: {
        t,
        setShowInputs,
        setInputs,
        setShowCancelModal,
      },
      showSuccessModal: {
        actions: { setShowSuccessModal },
        ctx: { t, updatedProductsList, blockedProductsList },
      },
    },
  };
};